"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComputedItemModule = /** @class */ (function () {
    function ComputedItemModule() {
    }
    return ComputedItemModule;
}());
exports.ComputedItemModule = ComputedItemModule;
